export default "__VITE_ASSET__CuMP7QFL__"